const imgZoom = () => {
  const style = `.cpb-zoom-img-container {
    position: absolute;
    overflow: hidden;
    background-color: #FFF;
    border: 2px solid black;
    border-radius: 8px;
    opacity: 0;
    transform: translateY(20px);
    box-shadow: 2px 1px 20px 6px #00000024;
    z-index: 10;
  }
  
  .cpb-zoom-img-container.show {
    transform: translateY(0px);
    opacity: 1;
  }`;
  const styleElem = document.createElement('style');
  styleElem.textContent = style;
  document.head.appendChild(styleElem);

  let transitionDuration = 300;
  
  const elemsList = document.querySelectorAll('.grid-product__wrapper img.product--image');

  const mouseEnterHandle = (e) => {
    let scale = 3;
    let circleWidth = 200
    let addWidth = 0;
    let addHeight = 0;
    const DOMRect = e.target.getBoundingClientRect();
    const activeSlide = document.querySelector('.swiper-slide-active');
    const url = e.currentTarget.srcset.split(', ').at(-1).split(' ')[0];
    const img = document.createElement('img');
    img.src = url;
    img.style.maxWidth = 'none';
    
    const container = document.createElement('div');
    container.classList.add('cpb-zoom-img-container');
    container.appendChild(img);
    document.body.appendChild(container);
    
    container.style.width = `${circleWidth}px`;
    container.style.height = `${circleWidth}px`;
    container.style.transition = `transform ${transitionDuration}ms`;
    container.style.borderRadius = '50%';
    container.style.pointerEvents = 'none';

    container.classList.add('show');

    let transX = 0;
    let transY = 0;

    const updatePosition = (e) => {
      transX = ((e.clientX - DOMRect.x) * scale - (DOMRect.width + addWidth) / 2) * -1;
      transY = ((e.clientY - DOMRect.y) * scale - (DOMRect.height + addHeight)) * -1;

      container.style.top = `${e.clientY - (circleWidth / 2) + scrollY}px`;
      container.style.left = `${e.clientX - (circleWidth / 2)}px`;
      
      img.style.transform = `translateX(${transX}px) translateY(${transY}px)`;
    }


    e.target.addEventListener('mousemove', updatePosition);
  }

  const mouseLeaveHandle = () => {
    document.querySelector('.cpb-zoom-img-container').classList.remove('show');
    setTimeout(() => {
      document.querySelector('.cpb-zoom-img-container').remove()
    }, transitionDuration);
  }

  elemsList.forEach(el => {
    el.style.cursor = 'none';
    el.addEventListener('mouseenter', mouseEnterHandle);
    el.addEventListener('mouseleave', mouseLeaveHandle);
  })  
}


imgZoom();
